import templateUrl from './trip-planner-print.html';
import head from 'lodash/head';
import size from 'lodash/size';

export const tripPlannerPrintComponent = {
    bindings: {
        selectedServiceType: '<',
        directionDetails: '<',
        publicRouteDetails: '<',
        selectedProviderDetails: '<',
        privateTravelTime: '@',
        privateTravelTimeUnit: '@',
        isPrintWithMap: '@',
        encodedPrivateRoutePolyline: '@',
        onCancel: '&'
    },

    templateUrl,

    controller: class TripPlannerPrintComponent {
        constructor($parse) {
            'ngInject';

            this.$parse = $parse;
        }

        $onInit() {
            this._isPrintWithMap = this.$parse(this.isPrintWithMap || "false")(false);
            this.providersDetails = this._getTransportationProvidersDetails();
            this.privateProviderName = head(this.providersDetails).name;
            this.googleStaticMapUrl = this._getGoogleStaticMapUrl();
        }


        _getTransportationProvidersDetails() {
            return this.selectedServiceType.name === 'Public Transit' ? this.publicRouteDetails.details : [this.selectedProviderDetails]
        }

        _getClass(details, day) {
			return  details && day ?  details.daysOfOperation[day] === true ? 'activeDay' : 'inActiveDay' : '';
		}

        _getGoogleStaticMapUrl() {
            let staticMapUrl = 'https://maps.googleapis.com/maps/api/staticmap?size=640x640&path=color:0xFF4500|weight:5|';
            let encodedPolyline = this.selectedServiceType.name !== 'Public Transit' ? this.encodedPrivateRoutePolyline : this.publicRouteDetails.encodedPolyline;
            const path = `enc:${encodedPolyline}`;
            const googleApiKey = `key=AIzaSyAIRfLj2WaOYtX-nVAx357uM4y-Ygvw3e8`;
            const originMarker = `markers=color:green|${this.directionDetails.origin.latlng.lat},${this.directionDetails.origin.latlng.lng}`;
            const destinationMarker = `markers=color:red|${this.directionDetails.destination.latlng.lat},${this.directionDetails.destination.latlng.lng}`;
            let busStopsMarkers = "";
            let googleStaticMapUrl = `${staticMapUrl}${path}&${originMarker}&${destinationMarker}&${googleApiKey}`;

            if(this.directionDetails.type === "publicRoutes" && size(this.directionDetails.stops) > 0) {
                busStopsMarkers = this._getBusStopsMarker();
            }

            googleStaticMapUrl = busStopsMarkers ? `${googleStaticMapUrl}&${busStopsMarkers}` : googleStaticMapUrl;
            
            return googleStaticMapUrl;
        }

        _getBusStopsMarker() {
            let markers = this.directionDetails.stops.map(({latlng:{lat,lng}}) => `markers=color:orange|${lat},${lng}`);
            return markers.join('&');
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/common/components/trip-planner-print/trip-planner-print.component.js